import { Environment } from './env.interface';

export const environment: Environment = {
    production: true,
    apiEndpoint: 'https://test-dashboard-api.autoprop.ca/dashboard',
    wsEndpoint: 'https://test-ws.autoprop.ca',
    printStylesUrl: 'https://test-dashboard.autoprop.ca/print-styles.css',
    intercomApiKey: 'awxixhsj',
    upscopeApiKey: 'mC1vf79REme46zfYfcEMjJBX',
    hotjarApiKey: '517484',
    hotjarSv: '6',
    gaApiKey: 'UA-64222824-6',
    gaMeasurementId: 'G-657TGVNFMH',
    gtmApiKey: 'GTM-WFW7V98',
    userflowApiKey: 'ct_ezhk24g2kbftpb7mjuhfnq5ujm',
    sentryEndpoint: 'https://ad04967e7269497bbbe2ba3ccf5d3638@sentry.io/1361129',
    sentryEnv: 'stage',
    stripeApiKey: 'pk_test_THHFK6P52JlvN2wQKolHbhMI',
    googleApiKey: 'AIzaSyA6IYsFVDcQxCGDEnEwiyZ06fIQNNWCHNE',
    mapboxApiKey: 'pk.eyJ1Ijoib2JsaXF1aXR5IiwiYSI6InBwQktfeTgifQ.G5KjCHip6b7SXMzh8bofMA',
    creaClientId: 'FM10ZP45vOkW4Sjjz6qve9L293KGm796',
    relevateClientId: 'hDF5ZBZ13EOOpsOdrpebClhbdIYi0OVm',
    offerlandDisabled: true,
    stratareportsUrl: 'https://dev.stratareports.ca/partners/autoprop/auth',
    resetLastLoginDisabled: false,
};
